// Custom html countdown timer
class Slideshow extends HTMLElement {
  constructor() {
    super();
  }

  getElements() {
    this.track = this.querySelector(".slideshow-track");
    this.slides = Array.from(this.track.querySelectorAll(".item"));
    this.nav = this.querySelector(".slideshow-nav");
    this.indicator_buttons = Array.from(
      this.nav.querySelectorAll(".indicator__button")
    );
    this.indicators = Array.from(this.nav.querySelectorAll(".indicator"));
    this.current_slide_idx = 0;
    this.previous_slide_idx = 0;
    this.animation_active = false;
  }

  getNextSlide() {
    if (this.current_slide_idx == this.slides.length - 1) {
      return 0;
    } else {
      return this.current_slide_idx + 1;
    }
  }

  transitionSlide(index) {
    if (index == this.current_slide_idx) {
      return;
    }
    this.animation_active = true;



    // Add leaving class to current slide
    this.slides[this.current_slide_idx].classList.add("leaving");
    // Add entering class to new slide
    this.slides[index].classList.remove("inactive");
    this.slides[index].classList.add("active");
    this.slides[index].classList.add("entering");
    return
  }

  transitionSlideEnd(slide) {
    slide.classList.remove("leaving");
    slide.classList.remove("active");
    slide.classList.add("inactive");
    this.slides[this.current_slide_idx].classList.remove("entering");
    this.updateIndicator(this.current_slide_idx);
    this.previous_slide_idx = this.current_slide_idx;
    this.animation_active = false;

  }

  goToSlide(index) {
    if (this.animation_active) {
      return;
    }
    this.transitionSlide(index);
    this.current_slide_idx = index;
    return
  }



  setupButtons() {
    // Loop over each indicator button and add an event listener
    this.indicator_buttons.forEach((button, index) => {
      button.addEventListener("click", () => {
        this.goToSlide(index);
      });
    });
  }

  setupSlides() {
    // Loop over each item and add an animationend event listener
    this.slides.forEach((slide, index) => {
      slide.addEventListener("animationend", () => {
        this.transitionSlideEnd(slide);
      });
    });
  }

  setupIndicators() {
    // Loop over each indicator and add an event listener
    this.indicators.forEach((indicator, index) => {
      indicator.addEventListener("animationend", () => {
        var next_slide = this.getNextSlide()
        this.goToSlide(next_slide);
      });
    });
  }

  updateIndicator(index) {
    // Remove the active class from current indicator
    this.indicators[this.previous_slide_idx].classList.remove("active");
    // Add the active class to the new indicator
    this.indicators[index].classList.add("active");
    return
  }

  // Setup on load
  connectedCallback() {
    this.getElements();
    this.setupButtons();
    this.setupIndicators();
    this.setupSlides();
  }
}

customElements.define("slideshow-landingpage", Slideshow);
